import { Component, OnInit, Input } from '@angular/core';
import { TechnicianService } from '../../../../services/technician.service';
import { MessageService } from 'primeng/api';
import { ConfirmationService } from 'primeng/api';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-technician-working-hours',
  templateUrl: './technician-working-hours.component.html',
  styleUrls: ['./technician-working-hours.component.scss'],
})
export class TechnicianWorkingHoursComponent implements OnInit {
  @Input() user;
  @Input() partnerId;
  @Input() messageService: MessageService;
  public busy: boolean = false;
  public workingHours: any = [];
  public model: any = {
    MondayStart: '',
    TuesdayStart: '',
    WednesdayStart: '',
    ThursdayStart: '',
    FridayStart: '',
    SaturdayStart: '',
    SundayStart: '',
    MondayEnd: '',
    TuesdayEnd: '',
    WednesdayEnd: '',
    ThursdayEnd: '',
    FridayEnd: '',
    SaturdayEnd: '',
    SundayEnd: '',
  };

  constructor(
    public technicianService: TechnicianService,
    private confirmationService: ConfirmationService,
    private translate: TranslateService,
  ) {
    let date = moment().startOf('day').toDate();
    this.workingHours.push({
      label: moment(date).format('HH:mm'),
      value: moment(date).format('HH:mm'),
    });
    for (let i = 0; i < 47; i++) {
      date.setMinutes(date.getMinutes() + 30);
      this.workingHours.push({
        label: moment(date).format('HH:mm'),
        value: moment(date).format('HH:mm'),
      });
    }
  }

  ngOnInit() {
    this.technicianService
      .getTechnicianWorkHours(
        this.user.Technician ? this.user.Technician.ID : this.user.ID,
      )
      .subscribe((hours) => {
        this.model = hours;
        if (this.model.TechnicianID === 0) {
          this.model.TechnicianID = this.user.Technician
            ? this.user.Technician.ID
            : this.user.ID;
        }
      });
  }

  saveHours() {
    this.busy = true;
    this.technicianService
      .saveTechnicianWorkHours(this.model)
      .subscribe((result) => {
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.modal.add_edit_user.technician_working_hours_form.working_hours_saved',
            { name: this.user.Name ? this.user.Name : this.user.Firstname },
          ),
        });
        this.busy = false;
      });
  }

  replicateCheck() {
    this.confirmationService.confirm({
      key: 'confirm_times',
      rejectLabel: this.translate.instant('general.no'),
      acceptLabel: this.translate.instant('general.yes'),
      header: this.translate.instant('general.confirm'),
      message: this.translate.instant(
        'bikeshop.modal.add_edit_user.technician_working_hours_form.update_other_days',
      ),
      accept: () => {
        this.model.TuesdayStart = this.model.MondayStart;
        this.model.WednesdayStart = this.model.MondayStart;
        this.model.ThursdayStart = this.model.MondayStart;
        this.model.FridayStart = this.model.MondayStart;
        this.model.TuesdayEnd = this.model.MondayEnd;
        this.model.WednesdayEnd = this.model.MondayEnd;
        this.model.ThursdayEnd = this.model.MondayEnd;
        this.model.FridayEnd = this.model.MondayEnd;
      },
    });
  }
}
